import React, { useState, useEffect, useContext } from "react";
import { useParams } from 'react-router-dom';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import "../AdminDashboard.css";
import refreshicon from "../../../images/refresh-2.svg"
import loader from "../../../images/Anlook.svg"
import MyContext from "../../../MyContext";
import NoIndex from "../../NoIndex";
function OrderSupport({ Admin }) {
  // Function Call Management ##############################################################################################################################################################################
  const getOneDayBackDate = () => {
    const oneDayBack = new Date();
    oneDayBack.setDate(oneDayBack.getDate() - 1); // Subtract 1 day
    const year = oneDayBack.getFullYear();
    const month = String(oneDayBack.getMonth() + 1).padStart(2, "0");
    const day = String(oneDayBack.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  // State Management anlook ##############################################################################################################################################################################
  const [Loading, setLoading] = useState();
  const [userID, setuserID] = useState('');
  const [Clients, setClients] = useState([]);
  const [firstLoad, setFirstLoad] = useState(true);
  const [startDate, setStartDate] = useState(getOneDayBackDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [startDateCurrent, setStartDateCurrent] = useState(getOneDayBackDate());
  const [endDateCurrent, setEndDateCurrent] = useState(getCurrentDate());
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [Orders, setOrders] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null); // For accordion logic
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const ordersPerPage = 15;
  // Filteration Function Call Management ##############################################################################################################################################################################
  const filteredOrders = Orders.filter(order =>
    Object.values(order).some(value =>
      value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);


  // Api Call Management ##############################################################################################################################################################################
  const getNewOrder = async () => {
    try {

      const requestBody = {
        adminId: Admin.pkid,
        userid: userID || "",
        statuses: [
          "received",
          "paid",
          "accepted",
          "prepared",
          "rejected",
          "refunded",
          "driver_assigned",
          "driver_confirmed",
          "driver_pickup_arrival",
          "delivery_picked",
          "driver_dropoff_arrival",
        ],
        fromdate: startDateCurrent,
        todate: endDateCurrent,
        latitude,
        longitude,
      };
      const response = await axios.post(
        `${baseUrl}/api/Admin/getAllClientsCatalogueOrders`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        setOrders(response.data.response);

      } else {
        setOrders([]);


      }
    } catch (error) {
      // console.error("Error fetching data:", error);
    } finally {
      if (firstLoad) {
        setLoading(false);
        setFirstLoad(false);
      }
    }
  };
  const FetchClientCall = async () => {
    setLoading(true);
    try {

      const UserDetail = {
        // userid: User.pkid,
        userid: Admin.pkid,
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/Admin/getAllClientList`,
        UserDetail,
        config
      );
      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);

        setClients(response.data.response);
  
        setLoading(false);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("error");
      console.error("Error updating Admin login:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    FetchClientCall()
  }, [])

  // UseEffect Management ##############################################################################################################################################################################
  useEffect(() => {
    // Set initial date range when component mounts


    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
      });
    } else {
      toast.error("Geolocation is not supported by your browser");
    }
  }, [startDateCurrent, endDateCurrent]);

  useEffect(() => {
    if (startDate && endDate) {
      getNewOrder();
    }

  }, [startDate, endDate, userID]);
  useEffect(() => {
    getNewOrder();
  }, [])

  return (
    <div className="marginRight">   <div
      className="p-4 bg-white"
      style={{
        height: "100vh",
        fontFamily: "Nunito,sans-serif",
      }}
    >  <NoIndex />
      <div className="px-4 justify-content-center">
        <div className="isancharr-campaign-container mb-4 bg-light">
          {/* Header Section */}
          <div className="isancharr-header d-flex justify-content-between">
            <h2 className="CreateCampaign">Orders Logs</h2>
            <div className="d-flex">

              {/* Action Buttons */}
              <div className="isancharr-actions">

                <button className="isancharr-refresh-btn" title='Refresh' onClick={() => getNewOrder()}>
                  <img src={refreshicon} alt="Refresh" />
                </button>
              </div>
            </div>
          </div>

          <hr />

          {/* Top Controls - Search & WhatsApp Number */}
          <div className="isancharr-controls d-flex justify-content-start">
            <input
              type="text"
              placeholder="Universal Search..."
              className="form-control w-50 me-2"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
            <select className="form-select" onChange={(e) => setuserID(e.target.value)}>
              <option value="">Select Client</option>
              {Clients.map((item, index) => (
                <option key={index} value={item.us_code}>
                  {item.us_code} : {item.us_name}
                </option>
              ))}
            </select>
          </div>
          <div></div>


        </div>


        {Loading ? (
          <div className=" m-5 p-5 d-flex justify-content-center">
            <div className=" d-flex flex-column align-items-center justify-content-center ">
              <div className="p-3">
                <div className="loader"> </div>
              </div>
              <div className="p-3">
                <img src={loader} alt="" height={40} />
              </div>
            </div>
          </div>
        ) : (
          <><div className="scrollable-table">
            <table className="table table-bordered table-hover">
              <thead style={{ borderRadius: "10px" }}>
                <tr
                  className="text-center greenColour py-4"
                  style={{
                    borderBottom: "1px solid #ccc",
                  }}
                >
                  <th
                    className="p-3 th-style"

                  >
                    Restaurent Name
                  </th>
                  <th
                    className="p-3 th-style"

                  >
                    Order Number
                  </th>
                  <th
                    className="p-3 th-style"

                  >
                    Order Amount
                  </th>
                  <th
                    className="p-3 th-style"

                  >
                    Order Type
                  </th>
                  <th
                    className="pb-3 th-style"

                  >
                    {" "}
                    Order Status
                  </th>
                  <th
                    className="pb-3 th-style"

                  >
                    Payment Status
                  </th>


                  <th
                    className="p-3 th-style"

                  >
                    Delivery Status
                  </th>

                  <th
                    className="p-3 th-style"

                  >
                    Payment Mode
                  </th>
                  <th
                    className="p-3 th-style"

                  >
                    Restaurent Number
                  </th>
                  <th
                    className="p-3 th-style"

                  >
                    Customer Number
                  </th>
                  <th
                    className="p-3 th-style"

                  >
                    Delivery Partner
                  </th>
                  <th
                    className="p-3 th-style"

                  >
                    Anlook                  </th>



                </tr>
              </thead>
              <tbody>
                {currentOrders.map((order, index) => (
                  <React.Fragment key={index}>
                    <tr
                      className="text-center"
                      onClick={() =>
                        setExpandedRow(expandedRow === index ? null : index)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <td>{order.organization_name || "N/A"}</td>
                      <td>{order.orderid || "N/A"}</td>
                      <td>{order.totalOrderPrice || "N/A"}</td>
                      <td>{order.orderType || "N/A"}</td>
                      <td>{order.status || "N/A"}</td>
                      <td>{order.payment_status || "N/A"}</td>

                      <td>{order.delivery_partner_status || "N/A"}</td>

                      <td>{order.payment_mode || "N/A"}</td>
                      <td>{order.restaurant_support_number || "N/A"}</td>
                      <td>{order.customer_mobile || "N/A"}</td>
                      <td>{order.delivery_person_number || "N/A"}</td>
                      <td>{order.anlook_support_number || "N/A"}</td>
                    </tr>
                    {expandedRow === index && (
                      <tr>
                        <td colSpan="10" className="bg-light px-4 py-3">
                          <div>
                            <strong>Customer Name:</strong>{order.customer_name}<br />
                            <div>
                              <h6 className="mb-2">Ordered Items</h6>
                              <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                  <thead>
                                    <tr className="text-center">
                                      <th>#</th>
                                      <th>Product</th>
                                      <th>Quantity</th>
                                      <th>Item Price</th>
                                      <th>Total Price</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {order.items?.map((item, idx) => (
                                      <tr key={item.id} className="text-center">
                                        <td>{idx + 1}</td>
                                        <td>{item.product_id}</td>
                                        <td>{item.quantity}</td>
                                        <td>{item.item_price}</td>
                                        <td>{item.total_price}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>

            </table>

          </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <p className="mb-0">Page {currentPage} of {totalPages}</p>
              <div>
                <button
                  className="btn btn-sm btn-secondary me-2"
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <button
                  className="btn btn-sm btn-success"
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>


          </>
        )}
      </div>
    </div></div>
  )
}

export default OrderSupport
